import React from "react";
import PropTypes from "prop-types";
import "react-confirm-alert/src/react-confirm-alert.css";
import "./index.scss";

const Confirm = ({ title, message, buttons, onClose }) => {
  return (
    <div className="custom-confirm-ui">
      <div className="title">{title}</div>
      <div className="message">{message}</div>
      <div>
        {buttons.map((item) => (
          <button
            className={item.className}
            type="button"
            onClick={() => {
              item.onClick();
              onClose();
            }}
            key={item.label}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

Confirm.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      onClick: PropTypes.func.isRequired,
      className: PropTypes.string.isRequired,
    }).isRequired
  ).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default Confirm;
